export default __webpack_public_path__ + "static/media/radio_button_checked_black_24dp.9a33b9ed.svg";